const InvoiceLineItemTypeEnum = {
    Normal: 'Normal',
    Subheading: 'Subheading',
    Subtotal: 'Subtotal',
    Custom: 'Custom',
    ManualEntry: 'ManualEntry',
}

export default InvoiceLineItemTypeEnum;